import { useSearch } from '@tanstack/react-router';
import { useActiveOrganization } from '../../contexts/auth';
import { CreateRubricFormContainer } from '../../contexts/rubrics';

export function RubricCreatePage() {
  const { organization } = useActiveOrganization();
  const { forkFrom } = useSearch({ from: '/authenticated/orgs/$orgSlug/rubrics/new' });

  return (
    <div className="space-y-6">
      <header className="space-y-1.5">
        <h1 className="text-[22px] font-semibold leading-tight tracking-tight text-foreground">
          Create a rubric
        </h1>
        <p className="text-[13.5px] leading-relaxed text-muted-foreground max-w-2xl">
          Define the dimensions and score bands for evaluating conversation quality.
        </p>
      </header>
      {organization && (
        <CreateRubricFormContainer orgId={organization.id} forkFromRubricId={forkFrom} />
      )}
    </div>
  );
}
